import React, { useContext } from "react";

import {
    Box,
    Checkbox,
    Typography
} from "@mui/material";

import { TreeItem, TreeView } from '@mui/lab';

import { ArrowDropDown, ArrowRight, } from '@mui/icons-material';
import RoomIcon from '@mui/icons-material/Room';

import { UfficiContext } from "../UfficiContext";

const getAllTipiUfficiTreeIds = (tipiUffici, padreId = null) => {
    var tipiUfficiIds = tipiUffici.filter(x => x.padreId == padreId)?.map(x => x.id);
    if (tipiUfficiIds && tipiUfficiIds.length > 0) {
        var tempTipiUfficiIds = [];
        tipiUfficiIds.forEach(x => tempTipiUfficiIds = [...tempTipiUfficiIds, ...getAllTipiUfficiTreeIds(tipiUffici, x)]);
    }
    if (tempTipiUfficiIds?.length > 0)
        tipiUfficiIds = [...tipiUfficiIds, ...tempTipiUfficiIds]
    return tipiUfficiIds;
}

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

const renderTipiUfficiTree = (tipiUffici, activeTipiUfficiIds, setActiveTipiUfficiIds, padreId = null) => {

    if (tipiUffici.filter(x => x.padreId == padreId).some(x => x.competenza)) {
        tipiUffici = tipiUffici.sort((a, b) => a.competenza?.ordine.localeCompare(b.competenza?.ordine));
    } else {
        tipiUffici = tipiUffici.sort((a, b) => a.nome.localeCompare(b.nome));
    }


    return tipiUffici
        .filter(x => x.padreId == padreId)
        .map(tipoUfficio => {
            var hasChildren = tipiUffici.some(x => x.padreId == tipoUfficio.id);
            return hasChildren ?
                <TreeItem
                    key={tipoUfficio.id}
                    nodeId={`${tipoUfficio.id}`}
                    label={
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {
                                    tipoUfficio.urlIcona ?
                                        <img width={24} src={tipoUfficio.urlIcona} />
                                        :
                                        <RoomIcon />
                                }
                                <Typography fontSize={14} marginLeft={1}>
                                    {tipoUfficio.nome}
                                </Typography>
                            </Box>
                            <Checkbox
                                checked={activeTipiUfficiIds.some(x => x == tipoUfficio.id)}
                                onClick={e => {
                                    e.stopPropagation();
                                    if (e.target.checked) {
                                        let temp = [...activeTipiUfficiIds, ...getAllTipiUfficiTreeIds(tipiUffici, tipoUfficio.id), tipoUfficio.id];
                                        temp = temp.filter(onlyUnique);
                                        setActiveTipiUfficiIds(temp);
                                    } else {
                                        let temp = [...getAllTipiUfficiTreeIds(tipiUffici, tipoUfficio.id), tipoUfficio.id];
                                        temp = temp.filter(onlyUnique);
                                        setActiveTipiUfficiIds(activeTipiUfficiIds.filter(x => !temp.some(y => y == x)));
                                    }
                                }}
                                sx={{ marginRight: 1, padding: 0.5 }}
                            />
                        </Box>
                    }>
                    {
                        tipiUffici.some(x => x.padreId == tipoUfficio.id) &&
                        renderTipiUfficiTree(tipiUffici, activeTipiUfficiIds, setActiveTipiUfficiIds, tipoUfficio.id)
                    }
                </TreeItem>
                :
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: "30px" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {
                            tipoUfficio.urlIcona ?
                                <img width={24} src={tipoUfficio.urlIcona} />
                                :
                                <RoomIcon />
                        }
                        <Typography fontSize={14} marginLeft={1}>
                            {tipoUfficio.nome}
                        </Typography>
                    </Box>
                    <Checkbox
                        checked={activeTipiUfficiIds.some(x => x == tipoUfficio.id)}
                        onClick={e => {
                            e.stopPropagation();
                            if (e.target.checked) {
                                let temp = [...activeTipiUfficiIds, ...getAllTipiUfficiTreeIds(tipiUffici, tipoUfficio.id), tipoUfficio.id];
                                temp = temp.filter(onlyUnique);
                                setActiveTipiUfficiIds(temp);
                            } else {
                                let temp = [...getAllTipiUfficiTreeIds(tipiUffici, tipoUfficio.id), tipoUfficio.id];
                                temp = temp.filter(onlyUnique);
                                setActiveTipiUfficiIds(activeTipiUfficiIds.filter(x => !temp.some(y => y == x)));
                            }
                        }}
                        sx={{ marginRight: 1, padding: 0.5 }}
                    />
                </Box>
        })
}

export const TipiUfficiFilter = ({
    searchText,
    itemsPerPage,
    disabled,
    onLoadMore,
    onActionClick,
    ...props
}) => {

    const {

        state,
        setState,

        isLoadingTipiUffici,
        getTipiUfficiAsync,

    } = useContext(UfficiContext);

    const {
        tipiUffici,
        tipiUfficiFilter,
    } = state;

    return (
        <>
            <TreeView
                sx={{ paddingRight: '16px', }}
                defaultCollapseIcon={<ArrowDropDown />}
                defaultExpandIcon={<ArrowRight />}>
                {
                    renderTipiUfficiTree(tipiUffici?.result ?? [], tipiUfficiFilter, (x) => setState({ tipiUfficiFilter: x }))
                }
            </TreeView>
        </>
    );
};
